export default __webpack_public_path__ + "static/media/icone-meus-conteudos.031b8400.svg";